<template>
  <!--弹窗-->
  <el-dialog width="80%" :title="title" :visible.sync="visible" :before-close="handleClose" top="5vh">
    <div>
        <div style="margin: 0 10%;">
            关键词搜索数据拉取：进入亚马逊关键词页面，然后点击插件添加的市场分析即可。
        </div>
        <img src="@/assets/course2.png" alt="" style="width: 80%;margin: 10px 10% 20px;">
        <div style="margin: 0 10%;">
            热词榜单数据拉取：进入亚马逊热词榜单页面，然后点击插件添加的市场分析即可。
        </div>
        <img src="@/assets/course1.png" alt="" style="width: 80%;margin: 10px 10%;">
    </div>
    <el-row style="margin-top:17px; ">
        <el-button style="float:right" size="mini" @click="handleClose">关闭</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
